import createNamespaceContext from './helper/createNamespaceContext';
export const AI_MATE_CONTEXT = 'aiMateCtx';
export const AIMateAnalyticsContext = createNamespaceContext(AI_MATE_CONTEXT, 'AIMateAnalyticsContext');